import React from "react";
import styles from "./STCareerHero.module.css";
import clsx from "clsx";
import Image from "next/image";
import { careerHeroImg } from "@/assets/images";

const parseDraftOrRaw = (content) => {
  if (!content) return "";
  if (typeof content === "object") {
    if (content.blocks && Array.isArray(content.blocks)) {
      return content.blocks.map((b) => b.text).filter(Boolean).join("\n");
    }
  }
  if (typeof content === "string") {
    try {
      const parsed = JSON.parse(content);
      if (parsed?.blocks && Array.isArray(parsed.blocks)) {
        return parsed.blocks.map((b) => b.text).filter(Boolean).join("\n");
      }
    } catch (e) {
      // raw text or html
    }
    return content.replace(/<[^>]*>/g, "").trim();
  }
  return String(content);
};

export const STCareerHero = ({ title, description, coverPhoto, imageUrlBase = "" }) => {
  const parsedTitle = parseDraftOrRaw(title);
  const parsedDescription = parseDraftOrRaw(description);

  const titleLines = parsedTitle
    ? parsedTitle.split("\n").filter((line) => line.trim().length > 0)
    : [];

  let imageSrc = careerHeroImg;
  if (coverPhoto) {
    if (
      typeof coverPhoto === "string" &&
      (coverPhoto.startsWith("http://") ||
        coverPhoto.startsWith("https://") ||
        coverPhoto.startsWith("/"))
    ) {
      imageSrc = coverPhoto;
    } else if (imageUrlBase) {
      imageSrc = `${imageUrlBase}${coverPhoto}`;
    } else {
      imageSrc = coverPhoto;
    }
  }

  return (
    <section
      className={clsx(
        styles.heroSection,
        "bg-clr-black d-flex align-items-center flex-column-reverse flex-xl-row",
      )}
    >
      <div
        className={clsx(
          styles.heroImgWrapper,
          "align-self-start flex-shrink-0",
        )}
      >
        <Image
          src={imageSrc}
          alt="career hero image"
          className="w-100 h-auto"
          width={600}
          height={600}
          priority
          unoptimized={typeof imageSrc === "string" && imageSrc.startsWith("http")}
        />
      </div>
      <div
        className={clsx(
          styles.heroTextWrapper,
          "text-clr-white text-center text-xl-start",
        )}
      >
        <h1 className={clsx(styles.heroTitle, "space-sm-mb fw-normal")}>
          {titleLines.length > 0 ? (
            titleLines.map((line, idx) => (
              <React.Fragment key={idx}>
                {idx > 0 && <span className="d-block">{line}</span>}
                {idx === 0 && line}
              </React.Fragment>
            ))
          ) : (
            <>
              Join the mission,
              <span className="d-block"> Be that change.</span>
            </>
          )}
        </h1>
        <p className={clsx("paragraph-text mb-0 text-clr-white-55 lh-base")}>
          {parsedDescription ||
            "Science can help us transition to a circular economy without cost escalation and it will need a lot of effort and scientific curiosity. Let’s bring that transition together."}
        </p>
      </div>
    </section>
  );
};

